import React from 'react';
import { allResources } from '../data/resources';
import { siteConfig } from '../data/siteConfig';
import { formatEuro } from '../utils/currency';
export function Offer() {
  const hasCheckout = Boolean(siteConfig.checkoutUrl);
  const ctaClass = 'inline-flex w-full justify-center whitespace-normal text-center rounded-full bg-coral-deep px-6 sm:px-8 py-4 text-base font-semibold text-white shadow-soft transition-colors duration-200';
  return <section id="offerta" aria-labelledby="offer-title" className="scroll-mt-16 bg-teal-soft px-5 sm:px-8 py-16 sm:py-24" data-id="element-173" data-mp="tz3jv7mwprb1">
      <div className="max-w-5xl mx-auto" data-id="element-174" data-mp="p24n0hbuz695">
        <h2 id="offer-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal text-center" data-id="element-175" data-mp="13y2gtsyb7yi7">
          Il tuo atelier creativo comincia qui
        </h2>

        <div className="mt-10 sm:mt-14 grid md:grid-cols-[1.25fr_1fr] rounded-[2rem] bg-ivory overflow-hidden shadow-soft" data-id="element-176" data-mp="2fbeqwlknxdct">
          <ul className="p-6 sm:p-10 divide-y divide-ink/10" data-id="element-177" data-mp="2acblv14on74u">
            {allResources.map(r => <li key={r.id} className="flex items-center gap-4 py-3.5 first:pt-0 last:pb-0" data-id="element-178" data-mp="pj5tym718ecy">
                <div className="h-16 w-16 shrink-0 rounded-xl overflow-hidden bg-sand" data-id="element-179" data-mp="ui8z06n0ikkx">
                  <img src={r.image} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-180" data-mp="zi5283nvy7zf" />
                </div>
                <div className="min-w-0" data-id="element-181" data-mp="13j74yuh0h265">
                  <p className="flex flex-wrap items-center gap-x-2 text-xs font-semibold text-coral-deep" data-id="element-182" data-mp="6tzink8kip16">
                    <span data-id="element-183" data-mp="bsashuyv4zje">{r.kind === 'guide' ? 'Guida principale' : `Bonus ${r.number}`}</span>
                    {r.kind === 'bonus' && r.referencePrice != null && <span className="whitespace-nowrap text-leaf" data-id="element-184" data-mp="ft4e2hou2294">
                        <span className="sr-only" data-id="element-185" data-mp="km5w2ykc6hwx">Prezzo singolo:</span>
                        <s className="font-medium text-leaf/70" data-id="element-186" data-mp="3k8vpsei4u46o">{formatEuro(r.referencePrice)}</s>{' '}
                        ORA GRATIS
                      </span>}
                  </p>
                  <p className="font-serif text-base sm:text-lg font-semibold text-teal leading-snug" data-id="element-187" data-mp="vfqvhxndb4q3">
                    {r.name}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="bg-sand p-8 sm:p-10 flex flex-col justify-center text-center" data-id="element-188" data-mp="155ahvdaahgpp">
            <p className="text-sm font-medium text-ink/75" data-id="element-189" data-mp="106h038nyz3jq">6 risorse digitali</p>
            <p className="mt-2 font-serif text-6xl sm:text-7xl font-semibold text-teal" data-id="element-190" data-mp="108jzgjb0i914">
              {siteConfig.price}
            </p>
            <p className="mt-3 text-sm text-ink/75" data-id="element-191" data-mp="7ibeykt07cjd">Pagamento unico · Nessun abbonamento</p>

            <div className="mt-8" data-id="element-192" data-mp="lhb21o0vbjdf">
              {hasCheckout ? <a href={siteConfig.checkoutUrl} className={`${ctaClass} hover:bg-coral-darker`} data-id="element-193" data-mp="liw03nme5kg1">
                  Acquista il kit — {siteConfig.price}
                </a> : <button type="button" disabled className={`${ctaClass} opacity-60 cursor-not-allowed`} data-id="element-194" data-mp="1wvygoiohqa07">
                  Acquista il kit — {siteConfig.price}
                </button>}
            </div>

            <p className="mt-5 text-[13px] leading-relaxed text-ink/70" data-id="element-195" data-mp="20ee0zf7tinus">
              Guide e modelli digitali da scaricare. Non vengono spediti libri
              stampati, materiali o strumenti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}